import React from 'react';
import axios from "../../containers/api";
import {Button, Card, CardBody, Row, Label, Input, FormGroup, Badge, Alert} from "reactstrap";
import {Colxx, Separator} from "../../components/common/CustomBootstrap";
 
import {showCatchError, toEnglishNumbers} from "../../helpers/Utils";

class AddFreighter extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            Data: [],
            FreighterCardNumber: "",
            DriverId: this.props && this.props.oneDriver.id,

        }
         console.log(this.props);
    }
    

    
    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        
        if (this.state.FreighterCardNumber === null || this.state.FreighterCardNumber === undefined || this.state.FreighterCardNumber.trim() === "") {
           
            error.push("وارد كردن هوشمند ناوگان الزامی میباشد.");
        }
        
        
        this.setState({errors: error});
        if (error.length === 0) {
            
            this.AddDriver();
            
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    

    AddDriver = () => {
        let model = {
   
            FreighterCardNumber: toEnglishNumbers(this.state.FreighterCardNumber),
            DriverId:  this.state.DriverId ,
    
        };

        this.props.showSpinner();
        axios.post('/api/v1/Driver/AddFreighter  ', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data !== null) {
                    if (res.data.statusCode === 200) {
                        this.setState({
                            Data: res.data.data
                        }, () => console.log(this.state.Data.data))
                        this.props.showAlert(res.data.data.message, "success");
                        //console.log(res.data.data);
                    }
                    else {
                        this.props.showAlert(res.data.errors[0], "error");  
                    }
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    render() {
        return (
            <>
                 

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column align-items-center">
                                <div className="d-flex flex-md-row flex-column flex-wrap justify-content-around align-items-center w-100">
                                  

                                    <FormGroup className="w-md-25 w-100 mx-1">
                                        <Label>هوشمند ناوگان</Label>
                                        <Input value={this.state.FreighterCardNumber} maxLength={7}
                                            onChange={(e) => this.setState({ FreighterCardNumber: e.target.value })}/>
                                        
                                    </FormGroup>
                                    <FormGroup className="w-md-25 w-100 mx-1">

                                    </FormGroup>
                                    <FormGroup className="w-md-25 w-100 mx-1">

                                    </FormGroup>

                                   
                                </div>

                                {this.state.errors.length === 0 ?
                                    null
                                    :
                                    <div>
                                        {(this.state.errors.map((error, i) => {
                                            return (
                                                <Alert color="danger" key={i}>{error}</Alert>
                                            )
                                        }))}
                                    </div>
                                }

                                <div className="mt-4">
                                    <Button className="mx-3 my-md-0 my-1" color="primary"
                                            onClick={() => this.props.showSweetAlert("آیا از ثبت این ناوگان مطمئن هستید؟", "", "warning", this.validateInputData)}>
                                        افزودن‌ 
                                    </Button>
                                 
                                </div>

                                 

                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                 
            </>
        )
    }
}

export default AddFreighter;